import React, { useEffect } from 'react';
import SelfiePhotoCaptureV3 from '@/apps/los/components/SelfiePhotoCaptureV3/SelfiePhotoCaptureV3';

interface SelfiePhotoCaptureProps {
  value?: any;
  onChange?: (data: any) => void;
  onDone?: () => void;
  registerSubmit?: (handler: () => Promise<boolean>) => void;
}

/**
 * Wrapper component for SelfiePhotoCaptureV3
 * to make it compatible with the journey builder system.
 *
 * This component wraps the full-featured selfie capture page which includes:
 * - Address validation and display
 * - GPS distance checking
 * - Camera permission handling
 * - Multi-screen flow (instructions, capture, review, upload)
 * - Error handling and retry mechanisms
 * - onDone callback support for journey advancement
 * - registerSubmit support for Continue button integration
 */
export default function SelfiePhotoCapture({ value, onChange, onDone, registerSubmit }: SelfiePhotoCaptureProps) {
  // Wrapper component for journey builder system
  // Passes onDone and registerSubmit callbacks to V3 component
  
  useEffect(() => {
    console.log('[SelfiePhotoCapture] Wrapper mounted (V3)', { value, hasOnDone: !!onDone, hasRegisterSubmit: !!registerSubmit });
  }, [value, onDone, registerSubmit]);

  // Pass callbacks to V3 component
  // When selfie upload is successful, V3 will call onDone() to advance journey
  return <SelfiePhotoCaptureV3 onDone={onDone} registerSubmit={registerSubmit} />;
}
